import type { CSSProperties, MouseEvent } from 'react';

export type TriState = 'empty' | 'checked' | 'partial' | 'blocked';

const ACCENT = 'var(--f7-theme-color, #007aff)';
const BLOCK = '#ff6b35';
const BORDER = 'var(--f7-list-item-border-color, var(--f7-list-border-color, #d1d1d6))';
const BG = 'var(--f7-list-bg-color, #fff)';

export function TriStateCheckbox({
  state,
  size = 22,
  onClick,
  ariaLabel,
  testId,
}: {
  state: TriState;
  size?: number;
  onClick?: (e: MouseEvent) => void;
  ariaLabel?: string;
  testId?: string;
}) {
  const filled = state === 'checked' || state === 'partial';
  const blocked = state === 'blocked';
  const style: CSSProperties = {
    flex: `0 0 ${size}px`,
    width: size,
    height: size,
    borderRadius: size >= 22 ? 6 : 5,
    border: `1.5px solid ${blocked ? BLOCK : filled ? ACCENT : BORDER}`,
    background: filled ? ACCENT : BG,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: filled ? '#fff' : BLOCK,
    fontSize: size >= 22 ? 14 : 12,
    fontWeight: 700,
    cursor: blocked ? 'not-allowed' : 'pointer',
    userSelect: 'none',
    boxSizing: 'border-box',
  };
  return (
    <span
      role="checkbox"
      aria-checked={state === 'checked' ? true : state === 'partial' ? 'mixed' : false}
      aria-disabled={blocked || undefined}
      aria-label={ariaLabel}
      data-testid={testId}
      style={style}
      onClick={(e) => {
        e.stopPropagation();
        if (!blocked) onClick?.(e);
      }}
    >
      {state === 'checked' ? '✓' : null}
      {state === 'blocked' ? (
        <i className="f7-icons" style={{ fontSize: size * 0.7, color: BLOCK, lineHeight: 1 }}>
          lock_fill
        </i>
      ) : null}
      {state === 'partial' ? (
        <span
          style={{
            width: size * 0.55,
            height: 3,
            background: '#fff',
            borderRadius: 1,
            display: 'inline-block',
          }}
        />
      ) : null}
    </span>
  );
}
